import * as i0 from '@angular/core';
import { booleanAttribute, Directive, Input, Component, ChangeDetectionStrategy, ViewEncapsulation, TemplateRef, ViewChild, ContentChild, ContentChildren, NgModule } from '@angular/core';
import { NgTemplateOutlet, NgIf, NgStyle } from '@angular/common';
import * as i1 from 'ng-zorro-antd/core/outlet';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import { __decorate } from 'tslib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i1$1 from 'ng-zorro-antd/core/config';
import { WithConfig } from 'ng-zorro-antd/core/config';
import * as i4 from 'ng-zorro-antd/skeleton';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import * as i2 from '@angular/cdk/bidi';
import { BidiModule } from '@angular/cdk/bidi';

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
function NzCardMetaComponent_Conditional_0_ng_template_1_Template(rf, ctx) {}
function NzCardMetaComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtemplate(1, NzCardMetaComponent_Conditional_0_ng_template_1_Template, 0, 0, "ng-template", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.nzAvatar);
  }
}
function NzCardMetaComponent_Conditional_1_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.nzTitle);
  }
}
function NzCardMetaComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, NzCardMetaComponent_Conditional_1_Conditional_1_ng_container_1_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r0.nzTitle);
  }
}
function NzCardMetaComponent_Conditional_1_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.nzDescription);
  }
}
function NzCardMetaComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, NzCardMetaComponent_Conditional_1_Conditional_2_ng_container_1_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r0.nzDescription);
  }
}
function NzCardMetaComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, NzCardMetaComponent_Conditional_1_Conditional_1_Template, 2, 1, "div", 3)(2, NzCardMetaComponent_Conditional_1_Conditional_2_Template, 2, 1, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.nzTitle ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.nzDescription ? 2 : -1);
  }
}
const _c0 = ["*"];
function NzCardTabComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c1 = () => ({
  rows: 4
});
function NzCardComponent_Conditional_0_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.nzTitle);
  }
}
function NzCardComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, NzCardComponent_Conditional_0_Conditional_2_ng_container_1_Template, 2, 1, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r0.nzTitle);
  }
}
function NzCardComponent_Conditional_0_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.nzExtra);
  }
}
function NzCardComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, NzCardComponent_Conditional_0_Conditional_3_ng_container_1_Template, 2, 1, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r0.nzExtra);
  }
}
function NzCardComponent_Conditional_0_Conditional_4_ng_template_0_Template(rf, ctx) {}
function NzCardComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NzCardComponent_Conditional_0_Conditional_4_ng_template_0_Template, 0, 0, "ng-template", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.listOfNzCardTabComponent.template);
  }
}
function NzCardComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 5);
    i0.ɵɵtemplate(2, NzCardComponent_Conditional_0_Conditional_2_Template, 2, 1, "div", 6)(3, NzCardComponent_Conditional_0_Conditional_3_Template, 2, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NzCardComponent_Conditional_0_Conditional_4_Template, 1, 1, null, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.nzTitle ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.nzExtra ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.listOfNzCardTabComponent ? 4 : -1);
  }
}
function NzCardComponent_Conditional_1_ng_template_1_Template(rf, ctx) {}
function NzCardComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, NzCardComponent_Conditional_1_ng_template_1_Template, 0, 0, "ng-template", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.nzCover);
  }
}
function NzCardComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nz-skeleton", 3);
  }
  if (rf & 2) {
    i0.ɵɵproperty("nzActive", true)("nzTitle", false)("nzParagraph", i0.ɵɵpureFunction0(3, _c1));
  }
}
function NzCardComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function NzCardComponent_Conditional_5_For_2_ng_template_2_Template(rf, ctx) {}
function NzCardComponent_Conditional_5_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "span");
    i0.ɵɵtemplate(2, NzCardComponent_Conditional_5_For_2_ng_template_2_Template, 0, 0, "ng-template", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const action_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("width", 100 / ctx_r0.nzActions.length, "%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", action_r2);
  }
}
function NzCardComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 4);
    i0.ɵɵrepeaterCreate(1, NzCardComponent_Conditional_5_For_2_Template, 3, 3, "li", 10, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.nzActions);
  }
}
let NzCardGridDirective = /*#__PURE__*/(() => {
  class NzCardGridDirective {
    constructor() {
      this.nzHoverable = true;
    }
    static {
      this.ɵfac = function NzCardGridDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzCardGridDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NzCardGridDirective,
        selectors: [["", "nz-card-grid", ""]],
        hostAttrs: [1, "ant-card-grid"],
        hostVars: 2,
        hostBindings: function NzCardGridDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ant-card-hoverable", ctx.nzHoverable);
          }
        },
        inputs: {
          nzHoverable: [2, "nzHoverable", "nzHoverable", booleanAttribute]
        },
        exportAs: ["nzCardGrid"],
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature]
      });
    }
  }
  return NzCardGridDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzCardMetaComponent = /*#__PURE__*/(() => {
  class NzCardMetaComponent {
    constructor() {
      this.nzTitle = null;
      this.nzDescription = null;
      this.nzAvatar = null;
    }
    static {
      this.ɵfac = function NzCardMetaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzCardMetaComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzCardMetaComponent,
        selectors: [["nz-card-meta"]],
        hostAttrs: [1, "ant-card-meta"],
        inputs: {
          nzTitle: "nzTitle",
          nzDescription: "nzDescription",
          nzAvatar: "nzAvatar"
        },
        exportAs: ["nzCardMeta"],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 2,
        consts: [[1, "ant-card-meta-avatar"], [1, "ant-card-meta-detail"], [3, "ngTemplateOutlet"], [1, "ant-card-meta-title"], [1, "ant-card-meta-description"], [4, "nzStringTemplateOutlet"]],
        template: function NzCardMetaComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, NzCardMetaComponent_Conditional_0_Template, 2, 1, "div", 0)(1, NzCardMetaComponent_Conditional_1_Template, 3, 2, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.nzAvatar ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.nzTitle || ctx.nzDescription ? 1 : -1);
          }
        },
        dependencies: [NgTemplateOutlet, NzOutletModule, i1.NzStringTemplateOutletDirective],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NzCardMetaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzCardTabComponent = /*#__PURE__*/(() => {
  class NzCardTabComponent {
    static {
      this.ɵfac = function NzCardTabComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzCardTabComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzCardTabComponent,
        selectors: [["nz-card-tab"]],
        viewQuery: function NzCardTabComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(TemplateRef, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
          }
        },
        exportAs: ["nzCardTab"],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function NzCardTabComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, NzCardTabComponent_ng_template_0_Template, 1, 0, "ng-template");
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NzCardTabComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NZ_CONFIG_MODULE_NAME = 'card';
let NzCardComponent = /*#__PURE__*/(() => {
  class NzCardComponent {
    constructor(nzConfigService, cdr, directionality) {
      this.nzConfigService = nzConfigService;
      this.cdr = cdr;
      this.directionality = directionality;
      this._nzModuleName = NZ_CONFIG_MODULE_NAME;
      this.nzBordered = true;
      this.nzBorderless = false;
      this.nzLoading = false;
      this.nzHoverable = false;
      this.nzBodyStyle = null;
      this.nzActions = [];
      this.nzType = null;
      this.nzSize = 'default';
      this.dir = 'ltr';
      this.destroy$ = new Subject();
      this.nzConfigService.getConfigChangeEventForComponent(NZ_CONFIG_MODULE_NAME).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.cdr.markForCheck();
      });
    }
    ngOnInit() {
      this.directionality.change?.pipe(takeUntil(this.destroy$)).subscribe(direction => {
        this.dir = direction;
        this.cdr.detectChanges();
      });
      this.dir = this.directionality.value;
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    static {
      this.ɵfac = function NzCardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzCardComponent)(i0.ɵɵdirectiveInject(i1$1.NzConfigService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.Directionality));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzCardComponent,
        selectors: [["nz-card"]],
        contentQueries: function NzCardComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, NzCardTabComponent, 5);
            i0.ɵɵcontentQuery(dirIndex, NzCardGridDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listOfNzCardTabComponent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listOfNzCardGridDirective = _t);
          }
        },
        hostAttrs: [1, "ant-card"],
        hostVars: 16,
        hostBindings: function NzCardComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ant-card-loading", ctx.nzLoading)("ant-card-bordered", ctx.nzBorderless === false && ctx.nzBordered)("ant-card-hoverable", ctx.nzHoverable)("ant-card-small", ctx.nzSize === "small")("ant-card-contain-grid", ctx.listOfNzCardGridDirective && ctx.listOfNzCardGridDirective.length)("ant-card-type-inner", ctx.nzType === "inner")("ant-card-contain-tabs", !!ctx.listOfNzCardTabComponent)("ant-card-rtl", ctx.dir === "rtl");
          }
        },
        inputs: {
          nzBordered: [2, "nzBordered", "nzBordered", booleanAttribute],
          nzBorderless: [2, "nzBorderless", "nzBorderless", booleanAttribute],
          nzLoading: [2, "nzLoading", "nzLoading", booleanAttribute],
          nzHoverable: [2, "nzHoverable", "nzHoverable", booleanAttribute],
          nzBodyStyle: "nzBodyStyle",
          nzCover: "nzCover",
          nzActions: "nzActions",
          nzType: "nzType",
          nzSize: "nzSize",
          nzTitle: "nzTitle",
          nzExtra: "nzExtra"
        },
        exportAs: ["nzCard"],
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 6,
        vars: 5,
        consts: [[1, "ant-card-head"], [1, "ant-card-cover"], [1, "ant-card-body", 3, "ngStyle"], [3, "nzActive", "nzTitle", "nzParagraph"], [1, "ant-card-actions"], [1, "ant-card-head-wrapper"], [1, "ant-card-head-title"], [1, "ant-card-extra"], [3, "ngTemplateOutlet"], [4, "nzStringTemplateOutlet"], [3, "width"]],
        template: function NzCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, NzCardComponent_Conditional_0_Template, 5, 3, "div", 0)(1, NzCardComponent_Conditional_1_Template, 2, 1, "div", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, NzCardComponent_Conditional_3_Template, 1, 4, "nz-skeleton", 3)(4, NzCardComponent_Conditional_4_Template, 1, 0);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, NzCardComponent_Conditional_5_Template, 3, 0, "ul", 4);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.nzTitle || ctx.nzExtra || ctx.listOfNzCardTabComponent ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.nzCover ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", ctx.nzBodyStyle);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.nzLoading ? 3 : 4);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.nzActions.length ? 5 : -1);
          }
        },
        dependencies: [NzOutletModule, i1.NzStringTemplateOutletDirective, NgTemplateOutlet, NgStyle, NzSkeletonModule, i4.NzSkeletonComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  __decorate([WithConfig()], NzCardComponent.prototype, "nzBordered", void 0);
  __decorate([WithConfig()], NzCardComponent.prototype, "nzBorderless", void 0);
  __decorate([WithConfig()], NzCardComponent.prototype, "nzHoverable", void 0);
  __decorate([WithConfig()], NzCardComponent.prototype, "nzSize", void 0);
  return NzCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzCardModule = /*#__PURE__*/(() => {
  class NzCardModule {
    static {
      this.ɵfac = function NzCardModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzCardModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzCardModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [NzCardComponent, NzCardMetaComponent, BidiModule]
      });
    }
  }
  return NzCardModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzCardComponent, NzCardGridDirective, NzCardMetaComponent, NzCardModule, NzCardTabComponent };
